import React, { useState } from 'react';
import { Trans } from '@lingui/react';
import { TransButtonDefault, TransButtonPrimary } from '../../../Atoms/Buttons';
import { ModalDialog } from '../../../Molecules/Dialogs';
import GenericTemplateName from '../../../Molecules/Settings/GenericTemplateName';

export default function ({ show, toggle, finish, existingGroups }) {
  const [disableSave, setDisableSave] = useState(false);
  const [newName, setNewName] = useState('');
  const [groupName, setGroupName] = useState('');

  return (
    <ModalDialog
      header={<Trans id="contract.name.dialog-title" />}
      help="help.contract.name"
      body={
        <GenericTemplateName
          documentType="CUSTOM"
          disableSave={setDisableSave}
          newName={newName}
          setNewName={setNewName}
          groupName={groupName}
          setGroupName={setGroupName}
          existingGroups={existingGroups}
        />
      }
      footer={
        <div>
          <TransButtonDefault onClickHandler={toggle} text="actions.cancel" />{' '}
          <TransButtonPrimary
            disabled={disableSave}
            onClickHandler={() => {
              finish(newName.trim(), groupName);
              toggle();
            }}
            text="common.apply"
          />
        </div>
      }
      show={show}
      toggle={toggle}
    />
  );
}
